import React, { useRef } from "react";
import { Link, useParams } from "react-router-dom";
import Logo from "../../image/Logo.png";
import SetExam from "../../part/setExam";



const TutorExamQuestion = () => {
    const { course_id } = useParams();
    const setExamRef = useRef(null);

    const handleAddExam = () => {
        // 3. Call the child method if the ref exists
        if (setExamRef.current) {
            setExamRef.current.addQuestion();
        }
    };
    return (
        <div className="dashboard">
            <header className="dash_header" >
               <Link to ="/tutor_dashboard"> <img src={Logo} alt="logo" className="logo" style={{ marginLeft: "5%" }} />
                <h2 className="company_name" >GEOINFOTECH <br />  <span>ACADEMY</span></h2></Link>
                {/* <button className="payment right" onClick={this.handleOnlineRedirect}>Online Courses</button>*/}
                <button className="payment right" onClick={handleAddExam}>Add Question</button> 
            </header>

            <SetExam exam_id = {course_id} ref={setExamRef}/>

        </div>
    )
}

export default TutorExamQuestion